module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Portuguese National Cemeteries")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The single Portuguese cemetery at Neuve Chapelle is administered by the "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Union Franco-Portuguaise")])]), _vm._v(" located at 61, Rue des Haies at Richebourg. The cemetery has suffered in the past from neglect and many of the headstones are in very poor condition and very difficult to read. Sadly, over 200 of the headstones mark the graves of unknown – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("disconhecido")]), _vm._v(" – soldiers.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2016fbb4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/14_fm029.vue
// module id = 99
// module chunks = 0